
import api from '@/plugins/api'
import { mapState } from 'vuex'
import Links from '~/components/picture/Links'
import Title from '~/components/Title'
import PictureList from '~/components/type/PictureList'
import BookList from '~/components/type/BookList'
import '~/assets/css/type.scss'
export default {
  name: 'materialpage',
  components: { Links, Title, PictureList, BookList },
  computed: {
    ...mapState('type', ['materialList', 'pictureList', 'bookList'])
  },
  head() {
    return {
      title: '红色素材',
      meta: [{
        hid: "material page",
        name: "description",
        content: "不忘初心红色素材"
      }]
    }
  },
  data() {
    return {
    };
  },
  watch: {
  },
  async fetch({ store, $axios }) {
    let books = await $axios.$post(api.getBookList, {page: 1, page_size: 8});
    store.commit('type/setBookList', books || {});

    let pictures = await $axios.$post(api.getNewsImageList, {page: 1, page_size: 8});
    store.commit('type/setPictureList', pictures || {});
  },
  mounted() {
    this.$store.commit('setNavWhite', true);
  },
  methods: {
  
  },
  destroyed() {
    this.$store.commit('setNavWhite', false);
  }
};
